module.exports = __webpack_public_path__ + "static/media/4_5.809aba07.svg";